<script lang="ts">
	import { datadogRum } from '@datadog/browser-rum';
	import { page } from '$app/state';
	import { brandsSlugs } from '$lib';
	import Breadcrumbs from '$lib/components/Breadcrumbs.svelte';
	import Title from '$lib/components/Title.svelte';
	import { m } from '$lib/paraglide/messages';

	import type { BrandsPageData } from './page.brands';

	datadogRum.setViewName('/brand');

	const { data }: { data: BrandsPageData } = $props();
</script>

<div class="full-container mx-auto">
	<Breadcrumbs class="mb-4" />

	<Title class="capitalize">
		{m.brands()}
	</Title>

	<div class="mb-4 flex flex-wrap gap-2 border-b border-neutral-300 pb-2">
		{#each Object.keys(data.groupedBrands) as letter (letter)}
			<a href="#brand-letter-group-{letter}" class="link text-3xl hover:underline">
				{letter.toUpperCase()}
			</a>
		{/each}
	</div>

	<div class="grid grid-cols-2 gap-x-4 gap-y-8 md:grid-cols-4">
		{#each Object.entries(data.groupedBrands) as [letter, brands] (letter)}
			<div id="brand-letter-group-{letter}">
				<h3 class="mb-2 text-3xl font-semibold uppercase">{letter}</h3>
				<ul>
					{#each brands as brand (brand)}
						<li>
							<a
								href="/{brandsSlugs[page.data.store.language]}/{brand.slug}"
								class="link hover:underline">{brand.name} ({brand.count})</a
							>
						</li>
					{/each}
				</ul>
			</div>
		{/each}
	</div>
</div>
